/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CourseId200,
  PutApiV1CourseId400,
  PutApiV1CourseId401,
  PutApiV1CourseId404,
  PutApiV1CourseId500,
  PutApiV1CourseIdMutationRequest,
  PutApiV1CourseIdMutationResponse,
  PutApiV1CourseIdPathParams,
} from "../../types/courseRegistrationController/PutApiV1CourseId.ts";
import { courseDetailViewModelSchema } from "../courseDetailViewModelSchema.ts";
import { courseEditorViewModelSchema } from "../courseEditorViewModelSchema.ts";

export const putApiV1CourseIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1CourseIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1CourseId200Schema = z.lazy(
  () => courseDetailViewModelSchema,
) as unknown as ToZod<PutApiV1CourseId200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CourseId400Schema =
  z.any() as unknown as ToZod<PutApiV1CourseId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CourseId401Schema =
  z.any() as unknown as ToZod<PutApiV1CourseId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1CourseId404Schema =
  z.any() as unknown as ToZod<PutApiV1CourseId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CourseId500Schema =
  z.any() as unknown as ToZod<PutApiV1CourseId500>;

export const putApiV1CourseIdMutationRequestSchema = z.lazy(
  () => courseEditorViewModelSchema,
) as unknown as ToZod<PutApiV1CourseIdMutationRequest>;

export const putApiV1CourseIdMutationResponseSchema = z.lazy(
  () => putApiV1CourseId200Schema,
) as unknown as ToZod<PutApiV1CourseIdMutationResponse>;
